import React from 'react';
import { ContactSection } from '../components/sections/ContactSection';
export function ContactPage() {
  return <>
      {/* Page Header */}
      <section className="bg-[#0B1F3A] text-white py-20" data-id="element-394">
        <div className="max-w-7xl mx-auto px-4 text-center" data-id="element-395">
          <h1 className="text-4xl lg:text-5xl font-bold mb-6" data-id="element-396">Contact Us</h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto" data-id="element-397">
            Get in touch with us today. We're here to help with all your medical
            transportation needs.
          </p>
        </div>
      </section>

      <ContactSection data-id="element-398" />
    </>;
}